
// Get the variant value from the radio buttons
let variantSize = '12-Pack Case';
jQuery(document).on('click', 'variant-radios input[type="radio"]+label', function(e) {
  // e.preventDefault();
  // jQuery(this).prev().prop('checked', true);
  variantSize = jQuery(this).prev().val();
});


jQuery('.quick-add__submit').on('click', function(e) {
  
  $('html').addClass('quick-buy-active');
     
  setTimeout(function() { 

    var id = $('quick-add-modal[open]').find('.quick-add-modal__content-info').data('id'); 
    console.log('id', id);
    $('#rc_shipping_interval_frequency').attr('name', 'frequency');
          setTimeout(oneTimeBuy, 10); 
    $('.product-form__submit').on('click', function(e) {
      e.preventDefault();
      var quantity = $('input[name=quantity]').val();
      var formData = $('.product-form').serializeArray();
      formData.push({name: 'productId', value: id});   
      formData.push({name: 'quantity', value: quantity});   
      formData.push({name: 'size', value: variantSize});   
  
      customAddToCart(formData);
      formData = '';
    });


function customAddToCart(data) {

  const formData = data.reduce((result, obj) => {
    const { name, value } = obj;
    result[name] = value;
    return result;
  }, {});
  
  console.log(formData);
  console.log('form data product id', formData.productId);


  if(formData.purchase_type === 'autodeliver') {
       if( formData.size === '12-Pack Case') {    
       console.log('12 pack case');
       console.log('form-id', formData.id);
        var twelvepackrecurring = $('#AddToCartCustom[data-id="'+formData.productId+'"').data('option-0');
        console.log('variant id', twelvepackrecurring);
          productData = {
              'id': twelvepackrecurring,
              'quantity': formData.quantity,
              'properties': {
                'shipping_interval_frequency': formData.frequency,
                'shipping_interval_unit_type': 'Weeks'
          	}
          }
         console.log('productData', productData);
  jQuery.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: productData,
      dataType: 'json',
      success: function() { 
        console.log('success');
      }
    });


} else {
  console.log('24 pack case');
  console.log('form-id', formData.id);
  
        var twentyfourpackrecurring = $('#AddToCartCustom[data-id="'+formData.productId+'"').data('option-1');
        console.log('variant-id', twentyfourpackrecurring);
        
          productData = {
              "id": twentyfourpackrecurring,
              "quantity": formData.quantity,
              "properties": {
                "shipping_interval_frequency": formData.frequency,
                "shipping_interval_unit_type": 'Weeks'
              }
          }
  console.log(productData);
  jQuery.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: productData,
      dataType: 'json',
      success: function() { 
        console.log('success');
      }
    });

    }

} else {
  
        productData = {
              "id": formData.id,
              "quantity": formData.quantity,
          }
  jQuery.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: productData,
      dataType: 'json',
      success: function() { 
        console.log('success');
      }
    });

    }

}
   
    }, 1000);
    
    
  });

function oneTimeBuy() {
 jQuery('#ShopNowContainer #rc_purchase_type_onetime').prop("checked", true);
}



// $(document).on('click', 'quick-add-modal[open] input[name="purchase_type"]', function() {
//   // Check if the radio input with the value "autodeliver" is checked
//   if ($('quick-add-modal[open] input[name="purchase_type"]:checked').val() === "autodeliver") {
//     // Get the element with the class "price-item"
//     var priceElement = $('quick-add-modal[open] .price-item--regular');
    
//     // Extract only the numbers and decimals from the element's text
    
//     // var priceText = priceElement.text().replace(/\D/g, '');
//     var priceText = priceElement.text().replace(/[^\d.]/g, "");

//     // Convert the extracted text to a number
//     var price = parseFloat(priceText);

//     // Reduce the price by 10%
//     var reducedPrice = (price * 0.1);
    
//     // Update the element with the reduced price
//     priceElement.text('$' + reducedPrice.toFixed(2));
//   }
// });
